import { Breadcrumb } from "@faire/retailer-visitor-shared/components/Breadcrumb/index";
import { useRetailerRoutingContext } from "@faire/retailer-visitor-shared/RetailerRoutingContextProvider";
import { getCategoryBreadcrumbOptions } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageAboveFold/__internal__/utils";
import { useLoggedOutCategoryPageCurrentCategory } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentCategory";
import { useLoggedOutCategoryPageMetaTags } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageMetaTags";
import { useStrictLocalization } from "@faire/web/common/localization";
import { IBreadcrumbOption } from "@faire/web/ui/Breadcrumbs";
import { trackCategoriesBreadcrumbNavClick } from "@faire/web-api--source/events/categories/click/breadcrumbNav";
import React, { useMemo } from "react";

export const LoggedOutCategoryPageBreadcrumb: React.FC<{
  className?: string;
}> = ({ className }) => {
  const categoryModel = useLoggedOutCategoryPageCurrentCategory();
  const { seoCategoryText } = useLoggedOutCategoryPageMetaTags();
  const { applied_filter_display_name } = seoCategoryText ?? {};
  const { strictLocalize } = useStrictLocalization();

  const routingContext = useRetailerRoutingContext();

  const breadcrumbOptions = useMemo(() => {
    return categoryModel
      ? getCategoryBreadcrumbOptions(
          categoryModel,
          strictLocalize,
          routingContext,
          applied_filter_display_name ?? ""
        )
      : [];
  }, [
    applied_filter_display_name,
    categoryModel,
    routingContext,
    strictLocalize,
  ]);

  return (
    <Breadcrumb
      className={className}
      hideRoot
      options={breadcrumbOptions}
      onClick={(option: IBreadcrumbOption) => {
        trackCategoriesBreadcrumbNavClick(option.path ?? "");
      }}
    />
  );
};
